import type { IconData } from '@stacksjs/iconify-core'

export const waterMelon: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"3\"><path stroke-linejoin=\"round\" d=\"M37.794 37.794c-9.002 9.003-23.245 9.57-32.909 1.703c-1.137-.926-1.246-2.565-.316-3.699c2.142-2.61 6.702-7.856 15.037-16.192S33.188 6.712 35.798 4.57c1.133-.93 2.773-.821 3.699.316c7.867 9.663 7.3 23.906-1.703 32.908\"/><path d=\"M33.047 6.904A18.45 18.45 0 0 1 39 20.5C39 30.717 30.717 39 20.5 39a18.45 18.45 0 0 1-13.595-5.954\"/><path stroke-linejoin=\"round\" d=\"m29 28l1 1m.467-11.307l.933.934M18.07 30.09l.934.933\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default waterMelon
